import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {HttpClientModule} from '@angular/common/http';

import { VendorModule } from '../core/vendor.module';

import { CoreModule } from '../core/core.module';
import { SecurityService } from '../security/security.service';
import { LoguedGuardService } from '../security/logued-guard.service';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { SharedServicesModule } from '../shared-services/shared-services.module';
import { SecurityModule } from '../security/security.module';

import { SugerenciaComponent } from './sugerencia/sugerencia.component';
import { SugerenciaListComponent } from './sugerencia/sugerencia-list.component';
import { SugerenciaAddEditComponent } from './sugerencia/sugerencia-add-edit.component';
import { SugerenciaResolver } from './sugerencia/sugerencia.resolver';

import { CategoriaProductoComponent } from './categoria-producto/categoria-producto.component';
import { CategoriaProductoListComponent } from './categoria-producto/categoria-producto-list.component';
import { CategoriaProductoAddEditComponent } from './categoria-producto/categoria-producto-add-edit.component';
import { CategoriaProductoResolver } from './categoria-producto/categoria-producto.resolver';

import { SubcategoriaProductoComponent } from './subcategoria-producto/subcategoria-producto.component';
import { SubcategoriaProductoListComponent } from './subcategoria-producto/subcategoria-producto-list.component';
import { SubcategoriaProductoAddEditComponent } from './subcategoria-producto/subcategoria-producto-add-edit.component';
import { SubcategoriaProductoResolver } from './subcategoria-producto/subcategoria-producto.resolver';

import { ProveedorComponent } from './proveedor/proveedor.component';
import { ProveedorListComponent } from './proveedor/proveedor-list.component';
import { ProveedorAddEditComponent } from './proveedor/proveedor-add-edit.component';
import { ProveedorResolver } from './proveedor/proveedor.resolver';

import { TalleComponent } from './talle/talle.component';
import { TalleListComponent } from './talle/talle-list.component';
import { TalleAddEditComponent } from './talle/talle-add-edit.component';
import { TalleResolver } from './talle/talle.resolver';

import { ProductoComponent  } from './producto.component';
import { ProductoAddEditComponent  } from './producto-add-edit/producto-add-edit.component';
import { ProductoListComponent  } from './producto-list/producto-list.component';
import { ProductoResolver } from './producto.resolver';
import { ProductoDetailsComponent } from './producto-details/producto-details.component';
import { ProductoImagenesUploadComponent } from './producto-imagenes-upload/producto-imagenes-upload.component';
import { ProductoProveedorListComponent } from './producto-proveedor-list/producto-proveedor-list.component';

import {SlideshowModule} from 'ng-simple-slideshow';
import {EscapeHtmlPipe} from './keep-html.pipe';
import { QuillEditorModule } from 'ngx-quill-editor';
import {NgxMaskModule} from 'ngx-mask';
import { ProductoDValidarDatosComponent } from './producto-validar-datos/producto-validar-datos.component';

import { TipoImpresionComponent } from './tipo-impresion/tipo-impresion.component';
import { TipoImpresionListComponent } from './tipo-impresion/tipo-impresion-list.component';
import { TipoImpresionAddEditComponent } from './tipo-impresion/tipo-impresion-add-edit.component';
import { TipoImpresionResolver } from './tipo-impresion/tipo-impresion.resolver';

import { ColorComponent } from './color/color.component';
import { ColorAddEditComponent } from './color/color-add-edit.component';
import { ColorListComponent } from './color/color-list.component';
import { ColorResolver } from './color/color.resolver';
import { ColorPickerModule } from 'ngx-color-picker';
import { CantidadTotalComponent } from './cantidad-total/cantidad-total.component';
import { PrecioModificacionComponent } from './modificacion-precio/precio-modificacion/precio-modificacion.component';
import { PrecioModificacionListComponent } from './modificacion-precio/precio-modificacion-list/precio-modificacion-list.component';
import { PrecioModificacionAddComponent } from './modificacion-precio/precio-modificacion-add/precio-modificacion-add.component';
import { ProductoCodigoDescuentoComponent } from './producto-codigo-descuento/producto-codigo-descuento.component';
import { ProductoAddMassiveComponent } from './producto-add-massive/producto-add-massive.component';

import { CategoriaProductoAddComponent } from './categoria-producto-add/categoria-producto-add.component';

import { VerificadorProductosComponent } from './verificador-productos/verificador-productos/verificador-productos.component';
import { CostoEnvioResolver } from '../pedido/costo-envio/costo-envio.resolver';
import { CategoriaProductoAddMassiveComponent } from './carga-masiva/categoria-producto-add-massive/categoria-producto-add-massive.component';
import { DestacadoProductoAddMassiveComponent } from './carga-masiva/destacado-producto-add-massive/destacado-producto-add-massive.component';
import { ProductosBuscadosComponent } from './productos-buscados/productos-buscados.component';
import { ProductosBuscadosFilterComponent } from './productos-buscados/filter/productos-buscados-filter/productos-buscados-filter.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CoreModule,
    VendorModule,
    SharedComponentsModule,
    SharedServicesModule,
    SecurityModule,
    SlideshowModule,
    QuillEditorModule,
    NgxMaskModule,
    ColorPickerModule,
  ],
  declarations: [
    SugerenciaComponent,
    SugerenciaListComponent,
    SugerenciaAddEditComponent,
    CategoriaProductoComponent,
    CategoriaProductoListComponent,
    CategoriaProductoAddEditComponent,
    SubcategoriaProductoComponent,
    SubcategoriaProductoListComponent,
    SubcategoriaProductoAddEditComponent,
    ProveedorComponent,
    ProveedorListComponent,
    ProductoProveedorListComponent,
    ProveedorAddEditComponent,
    ProductoComponent,
    ProductoAddEditComponent,
    ProductoListComponent,
    ProductoDetailsComponent,
    ProductoImagenesUploadComponent,
    ProductoDValidarDatosComponent,
    TalleComponent,
    TalleListComponent,
    TalleAddEditComponent,
    EscapeHtmlPipe,
    TipoImpresionComponent,
    TipoImpresionListComponent,
    TipoImpresionAddEditComponent,
    ColorComponent,
    ColorListComponent,
    ColorAddEditComponent,
    CantidadTotalComponent,
    PrecioModificacionComponent,
    PrecioModificacionListComponent,
    PrecioModificacionAddComponent,
    ProductoCodigoDescuentoComponent,
    ProductoAddMassiveComponent,
    CategoriaProductoAddComponent,
    VerificadorProductosComponent,
    CategoriaProductoAddMassiveComponent,
    DestacadoProductoAddMassiveComponent,
    ProductosBuscadosComponent,
    ProductosBuscadosFilterComponent,
  ],
  exports: [
    SugerenciaComponent,
    SugerenciaListComponent,
    CategoriaProductoComponent,
    CategoriaProductoListComponent,
    SubcategoriaProductoComponent,
    SubcategoriaProductoListComponent,
    ProveedorComponent,
    ProveedorListComponent,
    ProductoComponent,
    ProductoAddEditComponent,
    ProductoListComponent,
    ProductoProveedorListComponent,
    ProductoDetailsComponent,
    ProductoImagenesUploadComponent,
    ProductoDValidarDatosComponent,
    TalleComponent,
    TalleListComponent,
    TalleAddEditComponent,
    EscapeHtmlPipe,
    TipoImpresionComponent,
    TipoImpresionListComponent,
    ColorComponent,
    ColorListComponent,
  ],
  providers: [
    SecurityService,
    LoguedGuardService,
    SugerenciaResolver,
    CategoriaProductoResolver,
    SubcategoriaProductoResolver,
    ProveedorResolver,
    ProductoResolver,
    TalleResolver,
    TipoImpresionResolver,
    ColorResolver,
    CostoEnvioResolver
  ]
})
export class ProductoModule { }



// WEBPACK FOOTER //
// ./src/app/productos/producto.module.ts